import gql from 'graphql-tag';

export const LISTADO_TIPO_IMPUESTO = gql`
  query listadoTipoImpuesto {
    listadoTipoImpuesto {
      id
      descripcion
    }
  }
`
